import { LockKey, User } from "@phosphor-icons/react";
import { motion, useReducedMotion } from "motion/react";
import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { MotionButton } from "../components/MotionButton";
import { BrandLogo } from "../components/BrandLogo";
import { ErrorState } from "../components/States";

export function LoginPage() {
  const auth = useAuth();
  const reduced = useReducedMotion();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<unknown>();
  const [pending, setPending] = useState(false);
  if (auth.user) return <Navigate to="/" replace />;
  return <main className="login-page">
    <motion.section className="login-brand" initial={reduced ? false : { opacity: 0, x: -24 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.45 }}>
      <BrandLogo label="CaterMate" />
      <h1>Planung, Einkauf und Betrieb an einem Ort.</h1>
      <p>CaterMate führt Küchenplanung, Warenfluss und Verwaltung in einer verlässlichen Arbeitsoberfläche zusammen.</p>
    </motion.section>
    <motion.section className="login-panel" initial={reduced ? false : { opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.08 }}>
      <div><h2>Anmelden</h2><p>Verwenden Sie Ihr bestehendes CaterMate-Konto.</p></div>
      {Boolean(error) && <ErrorState error={error} />}
      <form onSubmit={async (event) => { event.preventDefault(); setPending(true); setError(undefined); try { await auth.login(username, password); navigate((location.state as { from?: string } | null)?.from || "/"); } catch (nextError) { setError(nextError); } finally { setPending(false); } }}>
        <label className="field"><span>Benutzername</span><div className="input-icon"><User size={18} /><input autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} required /></div></label>
        <label className="field"><span>Passwort</span><div className="input-icon"><LockKey size={18} /><input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /></div></label>
        <MotionButton type="submit" disabled={pending}>{pending ? "Anmeldung läuft..." : "Anmelden"}</MotionButton>
      </form>
    </motion.section>
  </main>;
}
